module.exports = __webpack_public_path__ + "img/caas3-m@2.66f289c0.jpg";